module.exports = __webpack_public_path__ + "static/media/r13.b0f21e07.jpg";